import { render, staticRenderFns } from "./album-window.vue?vue&type=template&id=499eb224&"
import script from "./album-window.vue?vue&type=script&lang=js&"
export * from "./album-window.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports